"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCapture = void 0;
const react_1 = require("react");
const usePostHog_1 = require("./usePostHog");
function useCapture() {
    const client = (0, usePostHog_1.usePostHog)();
    return (0, react_1.useCallback)((eventName, properties, options) => {
        return client === null || client === void 0 ? void 0 : client.capture(eventName, properties, options);
    }, [client]);
}
exports.useCapture = useCapture;
